<template>
	<Header />
	<main>
		<router-view />
	</main>
</template>

<script>
import Header from './components/Header.vue'
export default {
	name: 'App',
	components: {
			Header
	},
	mounted() {
		this.$router.push('/')
	}
}
</script>

<style lang="scss">
main {
	width: 100vw;
	height: 80vh;
}
</style>
